<template>
    <div>
      <ResultUpdates></ResultUpdates>
      <MobileResults v-if="mobile"/>
      <div v-else>
        <Overview v-if="overviewMode"></Overview>
        <BibleResults v-else-if="bibleMode"></BibleResults>
        <Results v-else></Results>
      </div>
    </div>
</template>

<script>
import Overview from '@/components/Overview.vue'
import BibleResults from '@/components/BibleResults.vue'
//import TavnitResults from '@/components/BibleResults.vue'
import Results from '@/components/Results.vue'
import ResultUpdates from '@/components/ResultUpdates'
import MobileResults from '@/components/MobileResults'
import {RunStates} from '@/store/runStates'

export default {  
  name: 'Home',
  components: {
    Overview,
    BibleResults,
 //   TavnitResults,
    Results,
    ResultUpdates,
    MobileResults
  },  
  mounted() {
  },    
  computed: {    
    mobile () {
      return this.$mq === 'xs'
    },
    overviewMode () {
      return this.$store.state.displayOverview
    },
    bibleMode () {
      return this.$store.state.displayBible
    },
    complete () {
      return this.$store.state.charuzitApiState === RunStates.COMPLETE
    }       
  },
  watch: {
    overviewMode (val) {
      if (!val && !this.mobile)
        window.scrollTo({top: 0, behavior: 'smooth'}); 
    },
    complete (val) {
      if (val && !this.mobile)
        window.scrollTo({top: 0, behavior: 'smooth'}); 
    }
  }      
}
</script>